import { render, staticRenderFns } from "./yongyaoteyixingfenxi.vue?vue&type=template&id=45cd4b1d&"
import script from "./yongyaoteyixingfenxi.vue?vue&type=script&lang=ts&"
export * from "./yongyaoteyixingfenxi.vue?vue&type=script&lang=ts&"
import style0 from "./yongyaoteyixingfenxi.vue?vue&type=style&index=0&id=45cd4b1d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports